export type TAtTextSupportedElements = 'label' | 'span' | 'p';

export enum ETextVariants {
  DEFAULT = 'default',
  DISCLAIMER = 'disclaimer',
  STAT = 'stat',
  LABEL = 'label',
}

export enum ETextSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
